export const DEFAULT_IMAGE_NAME = 'tenant_base.png';
export const DEFAULT_IMAGE = `https://resource.platform.dabeeo.co.kr/assets/tenants/${DEFAULT_IMAGE_NAME}`;
